import { ApiProperty } from "@nestjs/swagger";
import { IsOptional } from "class-validator";

export class PalletByIdDto {
    @ApiProperty()
    @IsOptional()
    palletId?: number;
}